import React from 'react'
import { ToastContainer } from 'react-toastify'
import TopNav from '../layouts/TopNav'
import "../Styles/licensingMenu.css"
import { Link, useNavigate } from 'react-router-dom'



const LicensingMenu = () => {
    const navigate = useNavigate();

    return (
        <div className='licenseMenuContainer'>
            <ToastContainer />
            <TopNav title='Licensing Menu' />
            <div className="modalContainer">
                <div className="licensePopup">
                    {/* <h1>My modal?</h1>   */}
                    <Link to={'/dashboard/register-license'}><button>Register Retail Outlet License</button></Link>
                    <br />
                    <Link to={'/dashboard/create-allocation'}><button>Create Daily Allocation</button></Link>
                    <br />
                    <Link to={'/dashboard/licenses'}><button>View all licences</button></Link>
                </div>
            </div>

        </div>
    )
}

export default LicensingMenu